import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import ResiduosGroup from '@utils/ResiduosGroup';
import Container from '@material-ui/core/Container';


import './styles.css'

const Residuos = (props) => {
  const [data, setData] = useState(props.data)
  const latestData = useRef(data)
  const handleSelectChange = (type, option, {id, label, isChecked}) => {
    const state = data[type][option]
    const newState = state.forEach((item) => {
      if (item.id === id) {
        item.isChecked = !item.isChecked
      } else if ((label === 'Nenhum') || (label !== 'Nenhum' && item.label === 'Nenhum')) {
        item.isChecked = false;
      }
      return item;
    })
    setData({ ...data, ...newState })
  }

  const handleInputText = ({target: {value}}, type, option, item) => {
    item.value = value;
    setData({...data})
  };

  const handleDataChanged = () => {
    const { dispatch } = props
    dispatch({
      type: 'ADD_TO_FORM',
      data: {
        Residuos: latestData.current,
      },
    })
  }

  useEffect(() => {
    latestData.current = data
  }, [data])

  useEffect(() => {
    return () => handleDataChanged()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <Container maxWidth="lg" className="container">
      <h1 className="mobile-title" style={{display: 'none'}}>3. Fontes de Poluição</h1>
      <div className="Form01">
        <ResiduosGroup
          data={data}
          handleSelectChange={handleSelectChange}
          handleInputText={handleInputText}
        />
      </div>
    </Container>
  )
}

export default connect((state) => ({
  data: state.form.Residuos,
}))(Residuos)
